var React = require('react');

function StarFull (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFAE9C","d":"m15 .133-4.45 9.13L.6 10.727l7.2 7.106-1.7 10.034 8.9-4.738 8.9 4.738-1.7-10.034 7.2-7.106-9.95-1.464z"}));
}

StarFull.defaultProps = {"width":"30","height":"28","fill":"none"};

module.exports = StarFull;

StarFull.default = StarFull;
